import React from "react";
import clsx from 'clsx';
import { styleText } from "../../blocks/Utils";
import Box from "@mui/material/Box";

export default (function Name(props){
	let { name: label } = props || {}

	let { style, animation } = props || {}

	let sx = { ' .form-title':{ textAlign: 'center' } }

	styleText(sx, '.form-title', style);

	let btnClassName = [];

	if(animation){
		btnClassName.push({ 'animated': true })
		btnClassName.push({ 'infinite': true })
		btnClassName.push(animation);
	}

	return <>
		{(label) && <><Box sx={sx} className={clsx(btnClassName)} >
			<div className={'form-title'}>{label}</div>
		</Box></>}
	</>
})